document.addEventListener("DOMContentLoaded", function() {
  // List of values to hide
  var strainsToHide = [
    "Blue Gummy - Indica",
    "Lucid Dream - Sativa",
    "Lemon Cherry Runtz - Sativa",
    "Cherry AK - Sativa",
    "La Bomba - Indica",
    "Unicorn Meat - Sativa"
  ];

  // Loop through each strain and hide its corresponding radio button and label
  strainsToHide.forEach(function(strain) {
    var inputElement = document.querySelector('input[name="strain"][value="' + strain + '"]');
    if (inputElement) {
      // Hide the input radio button
      inputElement.style.display = "none";

      // Hide the label associated with the radio button
      var labelElement = inputElement.nextElementSibling;
      if (labelElement) {
        labelElement.style.display = "none";
      }
    }
  });

 
if(window.location.pathname.includes('products')){
  // Minimum and maximum view count
  var minViews = 5;
  var maxViews = 40;
  var text = 'people watching this product now!';

  // Create the element
  var $viewCountElement = document.createElement('div');
  $viewCountElement.className = 'view-count-message';

  // Start with random number
  var currentViews = Math.floor(Math.random() * (maxViews - minViews + 1)) + minViews;
  $viewCountElement.innerHTML = '<span class="view-count-icon">👁️</span> <span class="view-count-number">' + currentViews + '</span> ' + text;

  // Place it in the page
  var $form = document.querySelector('.product-form');
  var $pickupOptions = document.querySelector('.Pickup_alert_badge');
  if ($pickupOptions) {
    $pickupOptions.parentElement.insertBefore($viewCountElement, $pickupOptions);
  } else if ($form) {
    $form.appendChild($viewCountElement);
  }

  // Function to update views every minute
  function updateViews() {
    var change = Math.floor(Math.random() * 7) - 3; // -3 to +3
    currentViews += change;
    if (currentViews < minViews) currentViews = minViews;
    if (currentViews > maxViews) currentViews = maxViews;

    $viewCountElement.querySelector('.view-count-number').innerText = currentViews;
  }

  // Update every 1 minute
  setInterval(updateViews, 60000);
}

});
